import AttendAllowanceCreatePage from './AttendAllowanceCreatePage';

export default AttendAllowanceCreatePage;
